import React, {
  Children,
  cloneElement,
  FC,
  isValidElement,
  ReactElement,
} from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';

import { Box, Flex } from '../../../layouts';
import { StyledFlexTitle } from './DrawerHeaderTitle/DrawerHeaderTitle';
import { DrawerHeaderProps } from './types';
import typeVariant from './variants/typeVariant';

const StyledContainer = styled(Box, {
  shouldForwardProp,
})<DrawerHeaderProps>(
  typeVariant,
  css({
    [`${StyledFlexTitle}`]: {
      p: 'base',
    },
  })
);

const DrawerHeader: FC<DrawerHeaderProps> = ({
  children: childrenProp,
  type = 'block',
}) => {
  const children = Children.map(childrenProp, (child) => {
    if (!isValidElement(child)) {
      return null;
    }

    return cloneElement(child as ReactElement<Partial<DrawerHeaderProps>>, {
      type,
    });
  });

  return (
    <StyledContainer type={type}>
      <Flex flexDirection="column" position="relative" width="100%">
        {children}
      </Flex>
    </StyledContainer>
  );
};

export default DrawerHeader;
